"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.row = exports.table = exports.actions = exports.cell = void 0;

var _util = require("../../../util");

const KEY_WIDTH_MAP = {
  ltp: '19.73%',
  ask: '21.57%',
  bid: '20.9%',
  iv: '10.2%',
  volume: '12.37%',
  values: '15.21%'
};

const cell = ({
  cssProps,
  theme
}) => {
  const {
    cellType = 'iv'
  } = cssProps;
  return {
    position: 'relative',
    boxShadow: (0, _util.boxShadow)(theme, [1, 1, 0, 0, 'ui3']),
    overflow: 'hidden',
    minWidth: KEY_WIDTH_MAP[cellType],
    verticalAlign: 'middle'
  };
};

exports.cell = cell;

const actions = ({
  cssProps,
  theme
}) => {
  const {
    direction = 'left',
    highlight
  } = cssProps;
  const isLeft = direction === 'left';
  const bgColor = highlight ? (0, _util.color)(theme, 'interactive.ui2.hover') : (0, _util.color)(theme, 'interactive.ui.hover');
  const transparentBgColor = (0, _util.hexToRgba)(bgColor, 0);
  return {
    background: "radial-gradient(circle, ".concat(bgColor, " 60%, ").concat(transparentBgColor, " 100%)"),
    opacity: 0,
    padding: (0, _util.spacing)(theme, 'small'),
    pointerEvents: 'none',
    position: 'absolute',
    transform: "translateX(".concat(isLeft ? '-20%' : '20%', ")"),
    transition: 'all 0.2s ease'
  };
};

exports.actions = actions;

const table = () => ({
  background: 'transparent',
  height: 48
});

exports.table = table;

const row = ({
  cssProps,
  theme
}) => {
  const {
    highlight = false,
    selectedType
  } = cssProps;
  return {
    boxShadow: (0, _util.boxShadow)(theme, [1, 1, 0, 0, 'ui3']),
    position: 'relative',
    overflow: 'hidden',
    height: 48,
    background: (0, _util.color)(theme, highlight && selectedType === 'none' && 'interactive.ui2.default' || selectedType === 'buy' && 'data.positiveSubtle' || selectedType === 'sell' && 'data.negativeSubtle' || 'interactive.ui.default'),
    '&:active': {
      background: (0, _util.color)(theme, highlight && selectedType === 'none' && 'interactive.ui2.active' || selectedType === 'buy' && 'data.positiveSubtle' || selectedType === 'sell' && 'data.negativeSubtle' || 'interactive.ui.active')
    },
    '&:hover': {
      background: (0, _util.color)(theme, highlight && selectedType === 'none' && 'interactive.ui2.hover' || selectedType === 'buy' && 'data.positiveSubtle' || selectedType === 'sell' && 'data.negativeSubtle' || 'interactive.ui.hover')
    },
    '&:hover [data-actions]': {
      opacity: selectedType === 'none' ? 1 : 0,
      transform: 'none',
      pointerEvents: 'initial'
    }
  };
};

exports.row = row;
//# sourceMappingURL=OptionChainRow.style.js.map